import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { EVENT_MENU_URL } from 'data/menu';
import { useInfiniteScroll } from 'hooks';
import { EnrollQuery } from 'queries';
import * as M from 'styles/mobile';
import * as S from './style';

function History() {
  const { id } = useParams<{ id: string }>();

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    EnrollQuery.useGetInfiniteByUser(Number(id));
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const items = data ?? [];

  return (
    <>
      <div css={M.card}>
        {items.map(({ event }, i) => (
          <Link
            key={`${event.id}-${i}`}
            to={`${EVENT_MENU_URL.행사}/${event.id}`}
            css={S.item}
          >
            <p>{event.title}</p>
            <span>{Number(event.volunteerHours || 0)}시간</span>
          </Link>
        ))}
        {!isLoading && items.length === 0 && (
          <p css={M.empty}>참여내역이 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default History;
